import React, { useState, useEffect } from "react"
import CardComponent from "./Card"
import moment from "moment"
import { Input, Label, Row, Col, Container, Card } from "reactstrap"
import axios from "axios"
import Spinners from "components/Common/Spinner"

const Home = () => {
  const [isLoading, setLoading] = useState(false)
  const [report, setReport] = useState([])
  const [startDate, setStartDate] = useState(
    moment().subtract(6, "days").format("YYYY-MM-DD")
  )
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"))
  const [filteredData, setFilteredData] = useState([])

  // Fetch report data once on mount
  useEffect(() => {
    const getReport = async () => {
      setLoading(true)
      try {
        const response = await axios.post(
          `https://marcopolo.prisms.in/api/teacher-staffAttendance/staffAttendanceApp`,
          {
            fromDate: startDate,
            tDate: endDate,
          },
          {
            headers: {
              Authorization: localStorage.getItem("Token")?.replace(/"/g, ""),
            },
          }
        )

        const responseData = response?.data?.data || []
        setReport(responseData)
        setFilteredData(responseData)
      } catch (error) {
        console.error("Error fetching report:", error)
      } finally {
        setLoading(false)
      }
    }

    getReport()
  }, [startDate, endDate])

  // Filter data on start/end date change
  useEffect(() => {
    if (!report.length) return

    const filtered = report.filter(item => {
      const itemDate = moment(item.date).format("YYYY-MM-DD")
      return itemDate >= startDate && itemDate <= endDate
    })

    setFilteredData(filtered)
  }, [startDate, endDate, report])

  return (
    <div className="page-content stroke-yellow-100">
      <Container className="p-0">
        <Card className="p-2">
              <h1
            className="text-center mt-2 mb-4 fs-2"
            style={{ color: "#3c3c3c", fontWeight: "600" }}
          >
            Staff Attendance
          </h1>
          <Row className="mb-3">
            <Col md={4}>
              <Label for="startDate">Start Date</Label>
              <Input
                id="startDate"
                type="date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </Col>
            <Col md={4}>
              <Label for="endDate" className="">
                End Date
              </Label>
              <Input
                id="endDate"
                type="date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
              />
            </Col>
          </Row>

          {isLoading ? <Spinners /> : <CardComponent data={filteredData} />}
        </Card>
      </Container>
    </div>
  )
}

export default Home
